import axios from 'axios'

const api = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
})

api.interceptors.request.use((config) => {
	if (
		(config.url === '/expenses' || config.url === '/incomes') &&
		config.method?.toUpperCase() === 'GET'
	) {
		const params = {
			sort: config.params.sort,
			textSearch: config.params.textSearch,
			...config.params.match,
			type: config.params.match.type || undefined,
			destinationType: config.params.match.destinationType || undefined,
			destinationNature: config.params.match.destinationNature || undefined,
			originType: config.params.match.originType || undefined,
			originNature: config.params.match.originNature || undefined,
			year: config.params.match.year || undefined,
			quarter: config.params.match.quarter || undefined,
			...config.params.paginate,
			level:
				config.params.level === 'quarter' ? 'federal' : config.params.level,
		}

		config.params = params
	}

	return config
})

export default api
